module.exports = __webpack_public_path__ + "img/logo.f021a417.png";